import { type Command } from 'prosemirror-state'

import { useMst } from '#state'

// Minimal facade over the active editor. Callers should depend on this shape
// rather than the underlying MST model
//
export interface EditorHandle {
  /**
   * Dispatches a ProseMirror command against the editor
   *
   * @returns `true` if the command was applied, `false` if it could not run
   * (either the command doesn't apply or no editor view is mounted)
   */
  invoke(command: Command): boolean
}

/**
 * Returns a handle to the current script's editor
 *
 * Intended for components that render only when a script is loaded. Throws
 * if no current script is set (callers need to know to use this hook only in
 * regions of the app that have a mounted editor already)
 */
export function useEditor(): EditorHandle {
  'use memo'

  // @TODO: replace eventually with an <EditorProvider> component
  const { currentScript } = useMst()

  if (!currentScript) {
    throw new Error('useEditor called without a current script')
  }

  return {
    invoke(command) {
      return currentScript.pmEditor.invoke(command)
    },
  }
}
